import FormButton from "../forms/FormButton";
import FormButtons from "../forms/FormButtons";
import HouseholdField from "../fields/HouseholdField";
import Placeholder from "../../Placeholder";
import React, {useState} from 'react';
import {Form, Formik} from "formik";
import {compose} from "redux";
import {duckify, singleDuck} from "../../../utils/duckify";
import {flashMessages, sharedPortalHouseholds} from "../../../ducks";
import {prefixKeys} from "../../../utils/objects";
import {withRouter} from "react-router";


const HouseholdEditor = ({duckMeta, flash, household = {}, router, save}) => {
  const [errors, setErrors] = useState({});
  const ready = !duckMeta.household || duckMeta.household.ready;
  const error = duckMeta.error;

  const onSubmit = (values, {validateForm}) =>
    save(values.household).then(() => {
      flash({message: "Household saved.", type: "success", dismissible: true});
      router.push("/profile");
    }).catch(response => {
      if (response.household) {
        setErrors(prefixKeys(response.household.errors, 'household.'));
        validateForm(); // push errors to formik
      }
    });

  return (
    <React.Fragment>
      <h1>Household Information</h1>

      {!ready && (<Placeholder.loading/>)}

      {ready && error && (
        <h2 className="error">Household Not Found</h2>
      )}

      {ready && !error && (
        <Formik
          initialValues={{household}}
          onSubmit={onSubmit}
          validate={() => errors}>
          {
            ({handleSubmit, validateForm}) => {

              const onSave = () => {
                setErrors({});
                validateForm().then(() => handleSubmit());
              };

              return (
                <Form className="sp-household-form sp-form">
                  <HouseholdField entity="household" required />
                  <FormButtons>
                    <FormButton style="outline-primary" onClick={() => router.push("/profile")}>Cancel</FormButton>
                    <FormButton onClick={onSave}>Save</FormButton>
                  </FormButtons>
                </Form>
              );
            }
          }
        </Formik>
      )}

    </React.Fragment>
  );
};

const mapDispatchToProps = (dispatch) => ({
  flash: (props) => dispatch(flashMessages.actions.show(props)),
  save: (household) => dispatch(sharedPortalHouseholds.actions.save(household)),
});

const mapDucksToProps = ({params}) => {
  const {id} = params;
  return id
    ? {household: singleDuck(sharedPortalHouseholds, id)}
    : {}
};

export default compose(
  withRouter,
  duckify(mapDucksToProps, undefined, mapDispatchToProps)
)(HouseholdEditor);
